import React from 'react'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'
import img from 'app/livbrite/resources/images/Group.png'
import { useCmsBlock } from 'lib/core/hooks'

export const Survey = () => {
  const staticBlock = useCmsBlock({
    id: CMS_BLOCK.HOME_SURVEY,
    isLazy: false

  })

  return (
    <Container>
      {staticBlock.content
        ? (
          <div
            dangerouslySetInnerHTML={{
              __html: staticBlock.content
            }}
          />
        )
        : (
          <SampleData />
        )}
    </Container>
  )
}

const SampleData = () => {
  return (
    <div>
      <h2>Just 3 easy steps</h2>
      <div className='steps-images'>
        <div>
          <img src={img} alt='survey-1' />
          <p>Take the survey.</p>
        </div>
        <div>
          <img src={img} alt='survey-2' />
          <p>Get Recommendations.</p>
        </div>
        <div>
          <img src={img} alt='survey-3' />
          <p>Browse products.</p>
        </div>
      </div>
      <a href='/'>
        <div className='button'>
          <p>Start Your</p>
          <p>Wellness Survey</p>
        </div>
      </a>
    </div>
  )
}
